import { axiosInstance } from ".."

const generatePaymentRequest = async (customerId,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/payment/link/${customerId}`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default generatePaymentRequest;